import * as Icons from "../assets-admin/icons-amenities";

export const AMENITIES = [
  { key: "swimming_pool", label: "Swimming Pool", icon: Icons.swimming_pool },
  { key: "gymnasium", label: "Gymnasium", icon: Icons.gymnasium },
  {
    key: "landscape_garden",
    label: "Landscape Garden",
    icon: Icons.landscape_garden,
  },
  { key: "clubhouse", label: "Clubhouse", icon: Icons.clubhouse },
  {
    key: "children_play_area",
    label: "Children's Play Area",
    icon: Icons.children_play_area,
  },
  {
    key: "yoga_meditation_area",
    label: "Yoga / Meditation Area",
    icon: Icons.yoga_meditation_area,
  },
  { key: "indoor_games", label: "Indoor Games", icon: Icons.indoor_games },

  { key: "party_lawn", label: "Party Lawn", icon: Icons.party_lawn },

  { key: "jogging_track", label: "Jogging Track", icon: Icons.jogging_track },
  {
    key: "senior_citizen_sitout",
    label: "Senior Citizen Sitout",
    icon: Icons.senior_citizen_sitout,
  },
  { key: "security_24x7", label: "24x7 Security", icon: Icons.security_24x7 },
  { key: "power_backup", label: "Power Backup", icon: Icons.power_backup },
  { key: "car_parking", label: "Car Parking", icon: Icons.car_parking },
  { key: "intercom", label: "Intercom", icon: Icons.intercom },
  {
    key: "rainwater_harvesting",
    label: "Rain Water Harvesting",
    icon: Icons.rainwater_harvesting,
  },
  {
    key: "sewage_treatment_plant",
    label: "Sewage Treatment Plant",
    icon: Icons.sewage_treatment_plant,
  },

  // Commercial
  {
    key: "high_speed_lift",
    label: "High-Speed Lift",
    icon: Icons.high_speed_lift,
  },
  {
    key: "firefighting_equipment",
    label: "Fire Fighting Systems",
    icon: Icons.firefighting_equipment,
  },
  {
    key: "cctv_surveillance",
    label: "CCTV Surveillance",
    icon: Icons.cctv_surveillance,
  },
  {
    key: "visitors_parking",
    label: "Visitors Parking",
    icon: Icons.visitors_parking,
  },
  {
    key: "maintenance_staff",
    label: "Maintenance Staff",
    icon: Icons.maintenance_staff,
  },
  { key: "cafeteria", label: "Cafeteria / Food Court", icon: Icons.cafeteria },
  {
    key: "conference_room",
    label: "Conference Room",
    icon: Icons.conference_room,
  },
  {
    key: "internet_wifi",
    label: "Wi-Fi Connectivity",
    icon: Icons.internet_wifi,
  },

  // Land
  {
    key: "gated_community",
    label: "Gated Community",
    icon: Icons.gated_community,
  },
  {
    key: "paved_compound",
    label: "Paved Compound",
    icon: Icons.paved_compound,
  },
  {
    key: "internal_street_lights",
    label: "Internal Street Lights",
    icon: Icons.internal_street_lights,
  },
  {
    key: "water_supply_24hr",
    label: "24x7 Water Supply",
    icon: Icons.water_supply_24hr,
  },
  {
    key: "electricity_connection",
    label: "Electricity Connection",
    icon: Icons.electricity_connection,
  },
  {
    key: "security_cabin",
    label: "Security Cabin",
    icon: Icons.security_cabin,
  },
  { key: "boundary_wall", label: "Boundary Wall", icon: Icons.boundary_wall },

  // Project / Common Facilities
  {
    key: "day_care_centre",
    label: "Creche / Day Care",
    icon: Icons.day_care_centre,
  },
  {
    key: "shopping_center",
    label: "Shopping Center",
    icon: Icons.shopping_center,
  },
  { key: "restaurant", label: "Restaurant", icon: Icons.restaurant },
  { key: "bar_lounge", label: "Bar / Lounge", icon: Icons.bar_lounge },
  {
    key: "power_substation",
    label: "Power Substation",
    icon: Icons.power_substation,
  },
  {
    key: "eco_friendly_zone",
    label: "Eco Friendly Zone",
    icon: Icons.eco_friendly_zone,
  },
];


export const getIcon = (key) => {
  if (!key) return null;
  return Icons[key] || null;
};